import React, {Fragment, SyntheticEvent, useEffect, useState} from "react";
import Paper from "@mui/material/Paper";
import {v4} from "uuid";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell"
import {s_char, s_char_talents} from "../../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import {ICharTalent} from "../../_interfaces/ICharTalent";
import HelpOutlineSharpIcon from "@mui/icons-material/HelpOutlineSharp";
import {s_app_mobile} from "../../_signals/s_app";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import CasinoOutlinedIcon from "@mui/icons-material/CasinoOutlined";
import TalentsEdit from "./TalentsEdit";
import EditIcon from "@mui/icons-material/Edit";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {rollerSetRoll} from "../../_helper/rollBehave";
import charcreate from "../../_helper/charcreate";
import updChar from "../../_sig_api/updChar";
import {styled} from "@mui/material/styles";
import {FormLabel} from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {TalentsUpdate} from "../../_api/BETalents";
import {InfoTalentSkillSubscriber} from "../../_helper/InfoTalentSkillBehave";
import {TalentSkillSubscriber} from "../../_helper/DataBehaves";
import {matrices} from "../../_helper/matrices";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

interface IProps {
    roll:boolean
}
function Talents({roll}:IProps) {

    useSignals();

    const [edit, setEdit] = useState('')
    const [ccFree, setCCFree] = useState(0)

    const mod_rank = [...Array(7).keys()];

    const cc_done_talents = () => {
        updChar([{k: 'cc_talents', v: true}])
        let char = s_char.value
        char.cc_talents = true;
        s_char.value = char
    }

    useEffect(() => {
        if (!s_char.value.cc_talents) calcUsedFree()
    }, [])

    const handleInfoPopOpen = (talentname: string, e: SyntheticEvent) => {
        const talent = TalentSkillSubscriber.value.find(s => s.talent && s.name === talentname)
        if (talent) {
            InfoTalentSkillSubscriber.next({popOpen: true, popEl: e.currentTarget, pop: talent})
        }
    }

    const calcUsedFree = () => {
        const usedFree = s_char_talents.value.reduce((s, talent) => {
            if (talent.free) return s
            else return s + talent.stepfree
        }, 0);

        setCCFree(charcreate.talente - usedFree);
    }

    const setRoll = (talent: ICharTalent) => {
        const roll: IRollerRoll = {
            attribute: talent.attribute,
            canusekarma: talent.karma,
            karma: false,
            step_mod: 0,
            step: talent.step,
            strain: talent.strain,
            title: talent.name,
            target: [],
            targetVS: '',
            vsnum: 0,
            vs:'',
            as: '',
            as_fix: false
        };
        rollerSetRoll(roll, true, false);
    }

    const talentOptionDifficulty = (lps) => {
        if (lps === 100) return 'Novize';
        if (lps === 200) return 'Geselle';
        if (lps === 300) return 'Hüter';
        if (lps === 500) return 'Meister';
        return '';
    }

    const changeTalentFreeSteps = (id: string, event: any) => {
        const {value} = event.target;

        let talents = s_char_talents.value

        talents = talents.map(t => {
            if (t.id === id) {
                t.step = value;
                t.stepfree = value;
                TalentsUpdate([t])
            }
            return t;
        });

        s_char_talents.value = talents
        calcUsedFree()
    }

    const talentRow = (talent: ICharTalent) => {

        if (roll && (Object.keys(matrices).includes(talent.name) || talent.name === 'Vielseitigkeit')) return null;

        return <TableRow style={{paddingTop: 10}} key={talent.id}>
            <TableCell width={'100%'}>
                <Stack direction={'row'} justifyContent="space-between">
                    <Stack direction={'column'} justifyContent="flex-end">
                        <span style={{fontWeight:'bolder'}}>{talent.name}</span>
                        {!roll ?<span style={{width: s_app_mobile.value ? '100%' : '20%'}}>
                            {talent.discipline !== 'Mensch' && !talent.optional ?
                                <span>{talent.discipline.slice(0, 8)}&nbsp;{talent.circle}</span>
                                :
                                <span>{talent.discipline.slice(0, 8)}&nbsp;{talentOptionDifficulty(talent.lpstart)}</span>
                            }
                        </span>:null}
                    </Stack>
                    {talent.name ?
                        <HelpOutlineSharpIcon fontSize={'small'}
                                              onClick={(e) => handleInfoPopOpen(talent.name, e)}/>
                        : null
                    }
                </Stack>
            </TableCell>

            <TableCell>
                <Stack spacing={2} direction="row">
                    {!s_char.value.cc_talents && !talent.free ? <Fragment>
                            <FormLabel>Frei</FormLabel>
                            <Select key={v4()}
                                    value={talent.stepfree || '0'}
                                    onChange={(e) => changeTalentFreeSteps(talent.id, e)}
                            >
                                {mod_rank.map(r => {
                                    return <MenuItem key={v4()} value={r}>{r}</MenuItem>
                                })
                                }
                            </Select>
                        </Fragment> :
                        !roll && <span>Stufe&nbsp;{talent.step}</span>
                    }

                    {!talent.free ?
                        !roll && s_char.value.cc_talents ?
                            <Button className={'btn'} size="small" onClick={() => setEdit(talent.id)}>
                                <EditIcon/>
                            </Button> : null
                        : null
                    }
                    {Object.keys(matrices).includes(talent.name) || talent.name === 'Vielseitigkeit' ?
                        null
                        :
                        <Button className={'btn'} size="small" onClick={() => setRoll(talent)}>
                            <CasinoOutlinedIcon/>
                        </Button>
                    }

                </Stack>
            </TableCell>

        </TableRow>
    }

    return <Fragment>
        <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
            <h3 style={{margin: "5px"}}>Talente
                {!s_char.value.cc_talents ? <Item>
                <span style={{color: ccFree < 0 ? 'red' : 'black'}}>
                {'verbleibende Punkte: ' + ccFree}
                </span>
                    {ccFree === 0 ? <Button onClick={cc_done_talents}>abschliessen</Button> : null}
                </Item> : null}
            </h3>
            <Paper key={v4()} style={{padding: 4}}>
                <TableContainer style={{maxHeight: s_app_mobile.value?'100%':450}}>
                    <Table stickyHeader style={{width: '100%'}} size="small">
                        <TableBody>
                            {s_char_talents.value.map((talent) => talentRow(talent))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

        </Paper>
        <TalentsEdit edit={edit} isOpen={setEdit}/>
    </Fragment>

}

export default Talents;
